import { Goal, ID } from '@griply/types';

import { hasOpenTasks } from './has-open-tasks';

export type GetLifeAreaTaskListGoalsOptions = {
  isGoalGrouping: boolean;
  showCompletedTasks: boolean;
  taskCounts?: Map<ID, number>;
};

export const getLifeAreaTaskListGoals = (
  sortedLifeAreaGoals: Goal[],
  {
    isGoalGrouping,
    showCompletedTasks,
    taskCounts,
  }: GetLifeAreaTaskListGoalsOptions,
): Goal[] =>
  sortedLifeAreaGoals.filter((goal) => {
    if (isGoalGrouping && goal.archivedAt) {
      return false;
    }

    if (showCompletedTasks) {
      return true;
    }

    return !(!!goal.completedAt && !hasOpenTasks(goal.id, taskCounts));
  });
